import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';

import SectionLayout from 'components/SectionLayout';
import SlideSection from 'components/SlideSection';
import MovieCard from 'components/cards/MovieCard';

const ConcertsRubrics = ({ rubrics }) => (
	<SectionLayout>
		{_(rubrics).map(({ path, title, block }) => (
			<SlideSection
				key={path}
				title={title}
				moreControl={{
					title: 'Все концерты',
					url: '/music/concerts/[[...pathParams]]',
					as: `/${path}`
				}}
				items={block}
			>
				{_(block).map((blockItem) => (
					<MovieCard key={blockItem._id} data={blockItem} />
				))}
			</SlideSection>
		))}
	</SectionLayout>
);

ConcertsRubrics.propTypes = {
	rubrics: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default ConcertsRubrics;
